const bulletSliders = document.querySelectorAll('.block-bullet-slider') as NodeListOf<HTMLElement>;

bulletSliders.forEach((el) => {
	const marqueeList = el.querySelector('.block-bullet-slider__no-marquee ul') as HTMLElement;
	const marqueeWidth = marqueeList.clientWidth;

	const setMarqueeSpeed = () => {
		const marqueeContainer = el.querySelector('.bullet-slider__container') as HTMLElement;
		marqueeContainer.setAttribute('style', '--animation-speed: ' + marqueeWidth / 60 + 's');
	};

	const setMarqueeClass = () => {
		const container = marqueeList.closest('.container') as HTMLElement;
		const containerWidth =
			container?.clientWidth -
			parseFloat(getComputedStyle(container).paddingLeft) -
			parseFloat(getComputedStyle(container).paddingRight);

		// if marquee width is less than container, display container, otherwise display marquee
		if (marqueeWidth > containerWidth) {
			if (!el.classList.contains('block-bullet-slider--marquee')) {
				el.classList.add('block-bullet-slider--marquee');
			}
		} else if (el.classList.contains('block-bullet-slider--marquee')) {
			el.classList.remove('block-bullet-slider--marquee');
		}
	};

	document.addEventListener('DOMContentLoaded', setMarqueeSpeed);
	document.addEventListener('DOMContentLoaded', setMarqueeClass);
	window.addEventListener('resize', setMarqueeClass);
});
